import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasConsent = localStorage.getItem('cookie_consent');
    if (!hasConsent) {
      // Show banner after 2 seconds
      setTimeout(() => setShow(true), 2000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-t border-gray-700 shadow-2xl">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-6 h-6 text-yellow-500 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-white font-semibold mb-1">🍪 Çerez (Cookie) Kullanımı</h3>
              <p className="text-gray-300 text-sm">
                Web sitemizde, kullanıcı deneyimini geliştirmek ve site trafiğini analiz etmek amacıyla çerezler kullanıyoruz. 
                Çerezler, kişisel verilerinizi içermez ve tamamen anonim istatistikler için kullanılır. 
                Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.
              </p>
            </div>
          </div>
          
          <div className="flex gap-3 flex-shrink-0">
            <Button
              onClick={handleDecline}
              variant="outline"
              className="border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              Reddet
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
            >
              Kabul Et
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
